import React, { ReactNode, useContext, useMemo } from 'react'
import { isProdNodeEnv, isTestEnv } from 'constants/Utils.constants'
import { usePosthogEnabled } from 'features/feature-flags/FeatureFlag.hooks'
import PostHogAnalyticsProvider from 'features/product-analytics/PostHogAnalyticsProvider'
import LogRocketAnalyticsProvider from 'features/product-analytics/LogRocketAnalyticsProvider'
import SkeletonAnalyticsProvider from 'features/product-analytics/SkeletonAnalyticsProvider'
import HighLevelEventsTracker from 'features/product-analytics/HighLevelEventsTracker'
import { ProductEvents } from 'features/product-analytics/Events.types'

export interface ProductAnalyticsContextValue {
  identify: (id: string, traits?: Record<string, any>) => void
  trackEvent: (event: ProductEvents) => void
  reset: () => void
}

export const ProductAnalyticsContext = React.createContext<ProductAnalyticsContextValue | undefined>(undefined)

export function useProductAnalyticsContext(): ProductAnalyticsContextValue {
  return useContext(ProductAnalyticsContext)!
}

export default function ProductAnalyticsProvider({ children }: { children: ReactNode }) {
  const POSTHOG_ENABLED = usePosthogEnabled()
  const MyProvider = useMemo(() => {
    if (!isProdNodeEnv || isTestEnv) {
      return SkeletonAnalyticsProvider
    }
    if (POSTHOG_ENABLED) {
      return PostHogAnalyticsProvider
    }
    return LogRocketAnalyticsProvider
  }, [POSTHOG_ENABLED])

  return (
    <MyProvider>
      <HighLevelEventsTracker />
      {children}
    </MyProvider>
  )
}
